<div class="tr"
     [ngClass]="{'selected': isSelected, 'routes-table-summary-row tr-summary': isSummaryRow}"
     cdkDropList
     [id]="dropListId"
     [cdkDropListConnectedTo]="allPanelIds"
     [cdkDropListSortingDisabled]="true"
     [cdkDropListDisabled]="isSummaryRow"
     (cdkDropListDropped)="onDrop.emit({resource: resource, event: $event})"
     (click)="onRowClick.emit({resource: resource, event: $event})"
     (dblclick)="onRowDoubleClick.emit({resource: resource, event: $event})">

               <!-- Merged Sticky Column: Checkbox + ID -->
            <div class="td col-id sticky-col layout-row layout-align-start-center gap-5">

              <app-bringoz-checkbox *ngIf="!isSummaryRow" [isChecked]="isSelected"
                                    (clickEvent)="onToggleSelection.emit({id: resource.id, isSelected: !isSelected})"
                                    style="flex-shrink: 0; display: flex;">
              </app-bringoz-checkbox>

              <bringoz-button *ngIf="isSummaryRow" type="tertiary" size="fit" (onClick)="onRowClick.emit({resource: resource, event: $event}); $event.stopPropagation()" (click)="$event.stopPropagation()"><bringoz-icon iconName="arrow-left" classSize="lg" fill="#484848"></bringoz-icon></bringoz-button>
              <div class="flex layout-row layout-align-start-center text-ellipsis gap-5" style="min-width: 0;">
                <span class="br-body-1 text-ellipsis font-weight-600">
                  {{ resource.resourceAllocation?.name || '---' }}
                </span>
              </div>
            </div>

            <!-- Vehicle Type -->
            <div *ngIf="settings?.columns?.vehicleType" class="td col-vehicle gap-5 text-ellipsis">
              <bringoz-icon [iconName]="resource.resourceAllocation?.vehicle?.type?.toLowerCase() || 'truck'" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.resourceAllocation?.vehicle?.name || '---' }}</span>
            </div>

            <!-- Logistic Vehicles -->
            <div *ngIf="settings?.columns?.logisticVehicles" class="td col-logistic-vehicle gap-5 flex-wrap">
              <div class="flex layout-row layout-align-start-center text-ellipsis gap-5">
                <bringoz-icon [iconName]="resource.resourceAllocation?.mainLogisticsVehicleReference?.vehicleType?.toLowerCase() || 'truck'" classSize="sm"></bringoz-icon>
                <span class="br-body-1 text-ellipsis">{{ resource.resourceAllocation?.mainLogisticsVehicleReference?.name || '---' }}</span>
              </div>
              <div *ngFor="let vehicle of resource.resourceAllocation?.attachedLogisticsVehicleReferences;" class="flex layout-row layout-align-start-center text-ellipsis gap-5">
                <bringoz-icon [iconName]="vehicle.vehicleType?.toLowerCase() || 'Trailer'" classSize="sm"></bringoz-icon>
                <span class="br-body-1 text-ellipsis">{{ vehicle.name || '---' }}</span>
              </div>
            </div>

            <!-- Time Window -->
            <div *ngIf="settings?.columns?.timeWindow" class="td col-time-window gap-5 text-ellipsis">
              <bringoz-icon iconName="time-window-outline" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.schedule | timeWindow }}</span>
            </div>

            <!-- Tags -->
            <div *ngIf="settings?.columns?.tags" class="td col-tags text-ellipsis">
              <app-bringoz-tags *ngIf="resource.resourceAllocation?.tags?.length" [tags]="resource.resourceAllocation.tags" [maxTags]="1"></app-bringoz-tags>
              <span *ngIf="!resource.resourceAllocation?.tags?.length" class="br-body-1 text-ellipsis">---</span>
            </div>

            <!-- Labels -->
            <div *ngIf="settings?.columns?.labels" class="td col-labels text-ellipsis">
              <app-bringoz-labels-display *ngIf="!!resource.resourceAllocation?.labels?.length" [labels]="resource.resourceAllocation.labels" maxItems="1"></app-bringoz-labels-display>
              <span *ngIf="!resource.resourceAllocation?.labels?.length" class="br-body-1 text-ellipsis">---</span>
            </div>

            <!-- Routes Count -->
            <div *ngIf="settings?.columns?.routesCount" class="td col-routes-count gap-5 text-ellipsis">
              <bringoz-icon iconName="route" classSize="sm"></bringoz-icon>
              <span class="br-body-2 text-ellipsis">
                {{ (resource.scheduleExtraData?.routesCount === 1 ? 'X_ROUTE' : 'X_ROUTES') | translate: { sum: (resource.scheduleExtraData?.routesCount || 0) } }}
              </span>
            </div>

            <!-- Route Names -->
            <div *ngIf="settings?.columns?.routeNames" class="td col-route-names gap-5 text-ellipsis">
              <bringoz-icon iconName="hash" classSize="sm"></bringoz-icon>
              <app-bringoz-items-list-display *ngIf="resource.routes?.length"
                                              class="flex"
                                              [items]="routeNames"
                                              [maxItems]="1">
              </app-bringoz-items-list-display>
              <span *ngIf="!resource.routes?.length" class="br-body-1 text-ellipsis">---</span>
            </div>

            <!-- Retrips -->
            <div *ngIf="settings?.columns?.retrips" class="td col-retrips gap-5 text-ellipsis">
              <bringoz-icon iconName="return" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ (resource.resourceAllocation?.disableRetrips ? 'No' : 'Yes') | translate }}</span>
            </div>

            <!-- Total Duration -->
            <div *ngIf="settings?.columns?.totalDuration" class="td col-total-duration gap-5 text-ellipsis">
              <bringoz-icon iconName="timer-outline" classSize="sm"></bringoz-icon>
              <span class="br-body-2 text-ellipsis">
                {{ totalDuration | bringozTimeConvert }}
              </span>
            </div>

            <!-- Load - Weight -->
            <div *ngIf="settings?.load?.weight" class="td col-load col-load-weight gap-5 text-ellipsis">
              <bringoz-icon iconName="weight" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.capacity?.weight | bringozWeight:true:'---' }}</span>
            </div>

            <!-- Load - Volume -->
            <div *ngIf="settings?.load?.volume" class="td col-load col-load-volume gap-5 text-ellipsis">
              <bringoz-icon iconName="volume" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.capacity?.dimensions?.cube | bringozVolume:false:'---' }}</span>
            </div>

            <!-- Load - Packages -->
            <div *ngIf="settings?.load?.packages" class="td col-load col-load-packages gap-5 text-ellipsis">
              <bringoz-icon iconName="package-outline" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.capacity?.numberOfPackages || '---' }}</span>
            </div>

            <!-- Load - Spots -->
            <div *ngIf="settings?.load?.spots" class="td col-load col-load-spots gap-5 text-ellipsis">
              <bringoz-icon iconName="spot" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.capacity?.numberOfSpots || '---' }}</span>
            </div>

            <!-- Load - Pallets -->
            <div *ngIf="settings?.load?.pallets" class="td col-load col-load-pallets gap-5 text-ellipsis">
              <bringoz-icon iconName="pallets" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.capacity?.numberOfPallets || '---' }}</span>
            </div>

            <!-- Load - Value -->
            <div *ngIf="settings?.load?.value" class="td col-load col-load-value gap-5 text-ellipsis">
              <bringoz-icon iconName="dollar-circle" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ totalIncome | bringozPrice:'---' }}</span>
            </div>

            <!-- Capacities -->
            <div *ngIf="settings?.capacity?.weight" class="td col-capacity col-capacity-weight gap-5">
              <bringoz-icon iconName="weight" classSize="sm" fill="#484848" openDelay="300"></bringoz-icon>
              <app-bringoz-capacity-bar *ngIf="resource.resourceAllocation?.capacity?.weight; else unlimitedWeight"
                                        [value]="((resource.capacity?.weight ?? 0) / resource.resourceAllocation.capacity.weight) * 100"
                                        [unit]="'%'"
                                        [severityThresholds]="severityThresholds"
                                        [showValue]="true"
                                        [ngbTooltip]="{ current: resource.capacity?.weight ?? 0, max: resource.resourceAllocation.capacity.weight } | capacityTooltipPipe:weightUnit"
                                        [tooltipClass]="weightSeverity">
              </app-bringoz-capacity-bar>

              <ng-template #unlimitedWeight>
                <div [ngbTooltip]="{ current: resource.capacity?.weight ?? 0, max: resource.resourceAllocation?.capacity?.weight } | capacityTooltipPipe:weightUnit" class="flex layout-row layout-align-start-center gap-5">
                  <div class="unlimited-container layout-row layout-align-center-center">
                    <span class="br-caption-1 font-weight-500" style="color: #484848; font-size: 10px;" translate>UNLIMITED</span>
                  </div>
                  <bringoz-icon iconName="infinite"></bringoz-icon>
                </div>
              </ng-template>
            </div>

            <div *ngIf="settings?.capacity?.volume" class="td col-capacity col-capacity-volume gap-5">
              <bringoz-icon iconName="volume" classSize="sm" fill="#484848" openDelay="300"></bringoz-icon>
              <app-bringoz-capacity-bar *ngIf="volumeCapacity; else unlimitedVolume"
                                        [value]="((resource.capacity?.dimensions?.cube ?? 0) / volumeCapacity) * 100"
                                        [unit]="'%'"
                                        [severityThresholds]="severityThresholds"
                                        [showValue]="true"
                                        [ngbTooltip]="{ current: resource.capacity?.dimensions?.cube ?? 0, max: volumeCapacity } | capacityTooltipPipe:volumeUnit"
                                        [tooltipClass]="volumeSeverity">
              </app-bringoz-capacity-bar>

              <ng-template #unlimitedVolume>
                <div [ngbTooltip]="{ current: resource.capacity?.dimensions?.cube ?? 0, max: volumeCapacity } | capacityTooltipPipe:volumeUnit" class="flex layout-row layout-align-start-center gap-5">
                  <div class="unlimited-container layout-row layout-align-center-center">
                    <span class="br-caption-1 font-weight-500" style="color: #484848; font-size: 10px;" translate>UNLIMITED</span>
                  </div>
                  <bringoz-icon iconName="infinite"></bringoz-icon>
                </div>
              </ng-template>
            </div>

            <div *ngIf="settings?.capacity?.pallets" class="td col-capacity col-capacity-pallets gap-5">
              <bringoz-icon iconName="pallets" classSize="sm" fill="#484848" openDelay="300"></bringoz-icon>
              <app-bringoz-capacity-bar *ngIf="resource.resourceAllocation?.capacity?.numberOfPallets; else unlimitedPallets"
                                        [value]="((resource.capacity?.numberOfPallets ?? 0) / resource.resourceAllocation.capacity.numberOfPallets) * 100"
                                        [unit]="'%'"
                                        [severityThresholds]="severityThresholds"
                                        [showValue]="true"
                                        [ngbTooltip]="{ current: resource.capacity?.numberOfPallets ?? 0, max: resource.resourceAllocation.capacity.numberOfPallets } | capacityTooltipPipe"
                                        [tooltipClass]="palletsSeverity">
              </app-bringoz-capacity-bar>

              <ng-template #unlimitedPallets>
                <div [ngbTooltip]="{ current: resource.capacity?.numberOfPallets ?? 0, max: resource.resourceAllocation?.capacity?.numberOfPallets } | capacityTooltipPipe" class="flex layout-row layout-align-start-center gap-5">
                  <div class="unlimited-container layout-row layout-align-center-center">
                    <span class="br-caption-1 font-weight-500" style="color: #484848; font-size: 10px;" translate>UNLIMITED</span>
                  </div>
                  <bringoz-icon iconName="infinite"></bringoz-icon>
                </div>
              </ng-template>
            </div>

          </div>
